export default __webpack_public_path__ + "static/media/wa.b3081d57.jpeg";